import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/**
 * @typedef {object} MosaicDndItemParams
 * @property {any} item - L'item à afficher
 * @property {string} modelName - Le nom du modèle de l'item à afficher
 */

/**
 * @param {MosaicDndItemParams} props
 */
export default function MosaicDndItem({item, modelName}) {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({id: item.id});

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div className={`mosaic__item mosaic__item--fixed`} style={style} {...attributes} {...listeners} ref={setNodeRef}>
      <img className="mosaic__image mosaic__image--no-radius" src={item.name} alt=""/>
      <div className="mosaic__section">
        <h4 className="mosaic__title">{item.title}</h4>
        <div className="mosaic__badges">
          <div className="mosaic__badge">Position : {item.position}</div>
        </div>
        <div className="mosaic__buttons">
          <a className="mosaic__button mosaic__button--icon" href={`/_edit/${modelName}/${item.id}`}><span className="material-icons">edit</span></a>
          <a className="mosaic__button mosaic__button--icon mosaic__button--danger" href={`/_delete/${modelName}/${item.id}`}><span className="material-icons">delete</span></a>
        </div>
      </div>
    </div>
  )
}
